import React from 'react';
import {translate} from 'utils/common';
import {PATH_PREFIX} from 'utils/constants'; 

import {Modal, ModalBody, ModalHeader } from 'reactstrap';
import Login from './login';
import FormMsg from './formmessage';
import {MsgPanel} from 'common/components';
import {getFromCache} from 'utils/querystring'; 

class Loginform extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            // modal: false,
            isLoading: true,
            postAction:false,
            signIn: this.props.signIn!=undefined ?this.props.signIn : true,msg:'', error:'', forgotPassword:false, msgTitle:''
        };
        this.toggleModal = this.toggleModal.bind(this);
        this.setAsSignIn = this.setAsSignIn.bind(this);
        this.setAsSignUp = this.setAsSignUp.bind(this);
        this.setAsForgotPassword = this.setAsForgotPassword.bind(this);
        this.loginCallBack = this.loginCallBack.bind(this); 
        this.setUserExistsOtherPortal = this.setUserExistsOtherPortal.bind(this);
        this.regnCallBack = this.regnCallBack.bind(this);
    } 
    regnCallBack(data){
        app.events.trigger(SHOW_LOADER, { status: true});
        dataService.postRequest("userSignin",data).then(res=>{                
            app.events.trigger(SHOW_LOADER, { status: false});
            if(res["status"] && res["status"] == "success") {
                // if(res.supplierId){
                    let userdata = res.userdata;
                    let userAuth = {...(res.appAuthTokenTO || {}), ...userdata};
                    // userAuth.authUserId = userdata.userId;        
                    ///TODO remove use of app.userAuth.userId across portal
                    // userAuth.userId = res.supplierId;
                               
                    // userAuth.supplierId = res.supplierId;
                    // userAuth.econtactId = res.econtactId;
                    app.events.trigger(USER_SIGNIN,userAuth,'login');
                    // this.props.nextStep({},userAuth,'login',this.signIn);
                // }
            }
        }).catch((error) => {
            app.events.trigger(SHOW_LOADER, { status: false});
            // this.setState({error: error ?error.message:'Error!'}); 
        }); 
    }
    toggleModal(params=[]) {
        var signIn = true;
        if(params.constructor == Array && params.length) signIn = params[0].signIn;
        this.setUserExistsOtherPortal(false);
        if(this.state.postAction && this.loginData){
            //app.events.trigger(USER_SIGNIN,this.loginData[0],this.loginData[1],this.loginData[2]);
            //this.loginData = null;
        }
        ////Code to login after successfull registration
        if(this.state.postAction && this.state.registeredData){
            let data={password: this.state.registeredData.password, useremail: this.state.registeredData.contactDetails.useremail}
            // if(this.props.regnCallBack)this.props.regnCallBack(data);            
            this.regnCallBack(data);            
        }
        this.setState(prevState => ({
            // modal: !prevState.modal,
            postAction:false,
            signIn:signIn,
            msg:'', error:'', msgTitle:'',
            forgotPassword:false
            // signIn:!params[0] || (params[0] && params[0].signIn)
        }));
        if(this.props.closeModal) this.props.closeModal();
    }
    setAsSignIn(){
       //!this.state.signIn && this.setState({signIn:true, forgotPassword:false});
          this.setState({signIn:true, forgotPassword:false, userExistsOtherPortal: false});
    }
    setAsSignUp(){
        ///this.state.signIn && this.setState({signIn:false, forgotPassword:false, userExistsOtherPortal: false});
        window.location.href = location.origin+PATH_PREFIX+'regn';
    }
    setAsForgotPassword(){
         this.setState({forgotPassword:true, userExistsOtherPortal: false});
    }
    loginCallBack(data,...loginData){
        if(this.state.signIn && loginData[1]=='login'){
            this.toggleModal();
        }
        else if(loginData[1]=='resetpassword'){ 
            this.setState({postAction:true,msg:data.msg, msgTitle:''});
            // dataService.getRequest('forgotPassword',{email:data.email}).then(res=>{
            //     if(res && res.status.toLowerCase() == STATUS.SUCCESS.toLowerCase()){
            //         this.setState({postAction:true,msg: translate('account.reset_mail_msg')});
            //     }
            //     else if(res && res.error){
            //         this.setState({postAction:true, msg:"",error: (res.error && res.errorCode)?translate(res.errorCode):'Error!'});
			//     } 
            // }).catch((error) => {
			// 	this.setState({postAction:true, msg:"",error: (error && error.errorCode)?translate(error.errorCode):'Error!'});
			// })
        }
        else{
            if(data.created){
                ///TODO//SHOW message from prop ///this.setState({postAction:true,msg:'login.signup_success'});
                if(this.props.completeCallBack) {
                    this.props.completeCallBack({message:translate('regn.signup_success_title').replace('{0}', data.name)});
                }
                else this.setState({registeredData:loginData[0], postAction:true,msg:data.msg, msgTitle:translate('regn.signup_success_title').replace('{0}', data.name)});
                //this.setState({postAction:true,msg:'login.signup_success'});
            }
        }
    }
    setUserExistsOtherPortal(userExistsOtherPortal){
        this.setState({'userExistsOtherPortal':userExistsOtherPortal})
    }
    render() {
        var {postAction, error, msg} = this.state;
        return (
            <div className="login-panel">
                <div className="header-sec">Sign In</div>
                <div className="login-text-sec">
                            <div className="tab-pane fade show active">
                                {/* {this.state.postAction && <FormMsg msg={translate(this.state.msg)} type="success"/>} */}
                                {msg && <MsgPanel title={this.state.msgTitle} type='success' msg={msg} onClick={this.toggleModal}/>} 
                                {error && <MsgPanel type='error' msg={error} onClick={this.toggleModal}/> } 
                                
                                {!postAction && 
                                    <Login signIn={this.state.signIn} email={this.state.email} forgotPassword={this.state.forgotPassword}
                                    forgotPwdClick={this.setAsForgotPassword}  
                                    fieldPrefix="login" nextStep={this.loginCallBack} setUserExistsOtherPortal={this.setUserExistsOtherPortal}
                                    
                                    userAlreadyExistsOtherPortal={this.props.userAlreadyExistsOtherPortal}
                                    allowEmailEdit={this.props.allowEmailEdit}
                                    data={this.props.data}
                                    />}
                            </div>
                            {/* {!postAction && this.state.signIn && !this.state.userExistsOtherPortal && <div className="d-flex justify-content-center align-items-center misc-link">                                                                
                                {!this.state.forgotPassword && <React.Fragment>
                                    <label className="m-0">{translate('regn.new_to_nocnoc')}  </label>
                                    <a className="ml-2" onClick={this.setAsSignUp}>{translate('signup')}</a>
                                </React.Fragment> }
                                {this.state.forgotPassword && <a onClick={this.setAsSignIn}>{translate('regn.back_to_signin')}</a>}
                            </div>} */}
                            {!postAction && !this.state.signIn && !this.state.userExistsOtherPortal && <div className="d-flex justify-content-center align-items-center">
                                <label className="m-0">{translate('login.already_account')} </label>
                                <a className="ml-2" onClick={this.setAsSignIn}>{translate('signin')}</a>
                            </div>}                            
                            
                        </div>
                
            </div>
        )
    }
}

export default Loginform
